import React from 'react'
import PropTypes from 'prop-types'

import Type from '@/component/Primitive/Type'

const ArticleLayoutStandfirstWidget = ({ article }) => {
  if (!article) return null

  return (
    <>
      {article?.sell && (
        <Type size={['heading8', 'heading5']} weight="bold">
          {article.sell}
        </Type>
      )}
    </>
  )
}

ArticleLayoutStandfirstWidget.propTypes = {
  article: PropTypes.shape({
    sell: PropTypes.string
  })
}

export default ArticleLayoutStandfirstWidget
